import { TESTIMONIALS } from "../lib/constants";
import { SectionHeader } from "./Shared";
import { Quote, Star } from "lucide-react";

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 bg-[#080808] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <SectionHeader
          eyebrow="Signal · client feedback"
          title={
            <>
              Verified,{" "}
              <span className="italic font-light text-white/60">peer-reviewed</span>{" "}
              results.
            </>
          }
          sub="Real clients. Real spaces. Reproducible outcomes."
        />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="rounded-3xl border border-white/10 bg-black/60 p-7 flex flex-col"
            >
              <Quote size={22} className="text-[#00E5FF]" />
              <p className="mt-5 font-body text-[15px] leading-relaxed text-white/80 flex-1">
                "{t.quote}"
              </p>
              <div className="mt-6 flex items-center justify-between border-t border-white/10 pt-5">
                <div>
                  <div className="font-display text-base font-semibold text-white">
                    {t.author}
                  </div>
                  <div className="text-xs font-body text-white/50 mt-0.5">
                    {t.role}
                  </div>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, j) => (
                    <Star
                      key={j}
                      size={12}
                      className="fill-[#00E5FF] text-[#00E5FF]"
                    />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
